module.exports = __webpack_public_path__ + "static/media/atsi.9e1e2f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/atsi.svg
// module id = 842
// module chunks = 0 1